module.exports = __webpack_public_path__ + "img/맞춤형제품선택아이콘.518c3e38.png";